import { render, staticRenderFns } from "./CatchCalibration.vue?vue&type=template&id=311c08b6&scoped=true"
import script from "./CatchCalibration.vue?vue&type=script&lang=js"
export * from "./CatchCalibration.vue?vue&type=script&lang=js"
import style0 from "./CatchCalibration.vue?vue&type=style&index=0&id=311c08b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c08b6",
  null
  
)

export default component.exports